var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSlNavBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #fff;\n        stroke: #52aff3;\n        stroke-width: 20px;\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 73.6,
    y: 74.1,
    width: 351.8,
    height: 351.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.6,368.5c-5.8,10.1-20.4,10.1-26.2,0l-91.7-158.4c-5.8-10.1,1.4-22.7,13.1-22.7h183.3c11.7,0,18.9,12.6,13.1,22.7l-91.6,158.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.6,288.9c-5.8,10.1-20.4,10.1-26.2,0l-91.7-158.6c-5.8-10.1,1.4-22.7,13.1-22.7h183.3c11.6,0,18.9,12.6,13.1,22.7l-91.7,158.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 249.7,
    y1: 315.8,
    x2: 249.7,
    y2: 381.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.5,
    cy: 381.9,
    r: 18.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 249.5,
    cy: 296.4,
    r: 18.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSlNavBar);
export default __webpack_public_path__ + "static/media/ico-SL-NavBar.1968e9850fc205237dfe4c411f802e24.svg";
export { ForwardRef as ReactComponent };